import { Component, OnInit, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MailServerService } from '../services/mailServer.service';
import { RingCentralCTService } from '../services/operations/ringcentral.service';
import { TwillioRCService } from '../services/operations/twilioRC.service';
import { UserSessionService } from '../services/usersession.service';
import { has } from 'lodash-es';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private userSessionService: UserSessionService,
    private twilioRCservice: TwillioRCService,
    private ringcentralCTService: RingCentralCTService,
    private mailServerSettings: MailServerService) { }

  isCallcenterUser = false;
  phoneSystem = 0;

  ngOnInit() {
    if (this.userSessionService && this.userSessionService.isCallcenterAgent) {
      this.isCallcenterUser = true;
    } else {
      this.isCallcenterUser = false;
    }
    this.CheckPhoneSystemTypes();
  }

  // Start Left Nav & Right Side ber script --------------------
  toggleClass(): void {
    (document.querySelector('#ContainerMain') as HTMLElement).classList.toggle('lft_toggled');
  }

  @HostListener('click', ['$event']) onClick(eve): void {
    if ((document.querySelector('#ContainerMain') as HTMLElement).classList.contains('lft_toggled') && eve.target.localName !== 'a' && eve.target.localName !== 'span') {
      this.toggleClass();
      // (document.querySelector('#ContainerMain') as HTMLElement).classList.remove('lft_toggled');
    }
  }

  openRingCentralWidget(): void {
    this.ringcentralCTService.openRingCentralWidget();
  }

  // End Left Nav & Right Side ber script --------------------

  CheckPhoneSystemTypes(): void {
    if (this.userSessionService.defaultPhoneSystem) {
      const phoneSystem = this.userSessionService.defaultPhoneSystem.PhoneSystemId;
      if (phoneSystem) {
        if (phoneSystem == 466) {
          this.ringcentralCTService.selectedPhoneSystem = phoneSystem;
          this.phoneSystem = phoneSystem;
          this.ringcentralCTService.ListenEvents();
          this.removeRCWidget();
        } else if (phoneSystem == 467) {
          this.loadRingCentralWidget();
          if (localStorage.getItem('rcTwilioPopup') == '1') {
            localStorage.setItem('rcTwilioPopup', '2');
            this.twilioRCservice.twilioCallEvent();
          }
        }
      }
    } else {
      this.mailServerSettings.checkPhoneSystemTypes().subscribe((response) => {
        if (response) {
          this.userSessionService.defaultPhoneSystem = response;
          const phoneSystem = response.PhoneSystemId;
          this.phoneSystem = phoneSystem;
          if (phoneSystem) {
            if (phoneSystem && phoneSystem == 466) {
              this.ringcentralCTService.selectedPhoneSystem = this.phoneSystem;
              this.ringcentralCTService.ListenEvents();
              this.removeRCWidget();
            } else if (phoneSystem && phoneSystem == 467) {
              this.loadRingCentralWidget();
              if (localStorage.getItem('rcTwilioPopup') == '1') {
                localStorage.setItem('rcTwilioPopup', '2');
                this.twilioRCservice.twilioCallEvent();
              }
            }
          }
        }
      });
    }
  }

  loadRingCentralWidget(): void {
    // Add the RingCentral Web Widget
    if (environment.ringcentralWidgetURL) {
      const rcs = document.createElement('script');
      rcs.src = environment.ringcentralWidgetURL;
      const rcs0 = document.getElementsByTagName('script')[0];
      rcs0.parentNode.insertBefore(rcs, rcs0);
      const rcWidget = document.getElementById('rc-widget');
      if (rcWidget) {
        rcWidget.style.display = 'block';
      }
    }
  }

  removeRCWidget(): void {
    const ele = document.getElementById('rc-widget');
    if (ele) {
      ele.remove();
    }
  }
}
